import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
const NAV_LINKS = [{
  label: 'How It Works',
  to: '/#how-it-works'
}, {
  label: 'Dispatch',
  to: '/dispatch-services'
}, {
  label: 'Back Office',
  to: '/compliance-back-office-support'
}, {
  label: 'Lease On',
  to: '/lease-on-with-fsg'
}, {
  label: 'FAQ',
  to: '/faq'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const goTo = (to: string) => {
    setIsMobileMenuOpen(false);
    if (to.startsWith('/#')) {
      const hash = to.slice(1);
      if (location.pathname === '/') {
        const target = document.querySelector(hash);
        if (target) {
          const offset = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      } else {
        navigate('/' + hash);
      }
    } else {
      navigate(to);
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg py-2' : 'bg-navy py-3'}`} data-id="element-246">
        <div className="container-custom" data-id="element-247">
          <div className="flex items-center justify-between" data-id="element-248">
            <Link to="/" className="flex-shrink-0 z-50 flex items-center -my-3" data-id="element-249">
              <img src="https://images.squarespace-cdn.com/content/v1/6983a647318f183e844ca503/e2a2c4ee-2ab0-4982-9580-c994819db0b2/FSGTrans%2BTrans.png" alt="FSG Transport" className="h-auto w-auto max-h-[60px] md:max-h-[72px] lg:max-h-[84px] object-contain" data-id="element-250" />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-251">
              {NAV_LINKS.map(link => <button key={link.label} onClick={() => goTo(link.to)} className="text-[15px] font-bold text-off-white/90 hover:text-white py-1 border-b-2 border-transparent hover:border-red transition-colors whitespace-nowrap" data-id="element-252">
                  {link.label}
                </button>)}
            </nav>

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center gap-4 xl:gap-5" data-id="element-253">
              <a href="tel:2346028424" className="btn-primary flex items-center gap-2 whitespace-nowrap" data-id="element-254">
                <Phone className="w-4 h-4 shrink-0" data-id="element-255" />
                234-602-8424
              </a>
            </div>

            {/* Mobile Actions */}
            <div className="flex items-center gap-2 lg:hidden z-50" data-id="element-256">
              <a href="tel:2346028424" className="text-white p-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-sm" aria-label="Call FSG" data-id="element-257">
                <Phone className="w-5 h-5" data-id="element-258" />
              </a>
              <button className="text-white p-2 -mr-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-sm" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen} aria-controls="mobile-menu" data-id="element-259">
                {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-260" /> : <Menu className="w-6 h-6" data-id="element-261" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div id="mobile-menu" className={`fixed inset-0 bg-navy z-40 transition-transform duration-300 ease-in-out lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
        top: '0',
        paddingTop: '80px'
      }} data-id="element-262">
          <div className="flex flex-col h-full px-6 pb-24 overflow-y-auto" data-id="element-263">
            <nav className="flex flex-col gap-5 mt-8" data-id="element-264">
              {NAV_LINKS.map(link => <button key={link.label} onClick={() => goTo(link.to)} className="text-left text-xl font-bold text-white uppercase tracking-wider border-b border-white/10 pb-4" data-id="element-265">
                  {link.label}
                </button>)}
            </nav>
            <div className="mt-10 flex flex-col gap-4" data-id="element-266">
              <a href="tel:2346028424" className="btn-primary w-full flex items-center justify-center gap-2 py-4 text-lg" data-id="element-267">
                <Phone className="w-5 h-5" data-id="element-268" />
                234-602-8424
              </a>
            </div>
          </div>
        </div>
      </header>
    </>;
}